import { doorHub } from './products/doorHub.mjs';
import { doorHubMini } from './products/doorHubMini.mjs';
import { elevatorHub } from './products/elevatorHub.mjs';
import { enterpriseAccessHub } from './products/enterpriseAccessHub.mjs';
import { gateHub } from './products/gateHub.mjs';
import { retrofitHub } from './products/retrofitHub.mjs';
import { uaUltra } from './products/uaUltra.mjs';
import './properties/index.mjs';
import { dimensions } from './properties/dimensions.mjs';
import { outputRelays } from './properties/outputRelays.mjs';
import { inputTerminals } from './properties/inputTerminals.mjs';
import { poePorts } from './properties/poePorts.mjs';
import { accessPowerMethod } from './properties/accessPowerMethod.mjs';
import { powerRedundancy } from './properties/powerRedundancy.mjs';
"use strict";
const AccessHubs = {
  properties: [dimensions, outputRelays, inputTerminals, poePorts, accessPowerMethod, powerRedundancy],
  columnWidth: 266,
  products: [enterpriseAccessHub, doorHub, doorHubMini, gateHub, elevatorHub, retrofitHub, uaUltra],
  propertyColumnWidth: 189,
  showBadges: true
};
export { AccessHubs };
//# sourceMappingURL=AccessHubs.mjs.map
